export default __webpack_public_path__ + "static/media/er8.accac3c1.jpg";